import Vue from 'vue'
// Libs start
import {
    Sketch,
} from 'vue-color'
import draggable from 'vuedraggable'
import Select2 from './plugins/v-select2-component'

// import NumberInputSpinner from 'vue-number-input-spinner';
import Modal from './components/modals/modal'
import Employee from './components/modals/specialist/employee'
import DeleteModal from './components/modals/deleteModal'
import ErrorModal from './components/modals/error'
import ModalCompany from './components/modals/modalCompany'
import EditApplication from './components/modals/editApplication'
import AddResponsible from './components/modals/addResponsible'
import AddResponsibleForPdf from './components/modals/addResponsibleForPdf'
import Tab from './components/controls/tab'
import TabResponsible from './components/controls/tabResponsible'
import TabCalendar from './components/controls/tabCalendar'
import UserList from './components/lists/users/userList'
import ClientsList from './components/lists/clients/clientsList'
import CompaniesList from './components/lists/companies/companiesList'
import Search from './components/controls/search'
import SearchButton from './components/controls/searchButton'
// import Call from './components/controls/call';
// Libs end

Vue.component('sketch-picker', Sketch)

// Components modals Start
Vue.component('modal', Modal)
Vue.component('employee', Employee)
Vue.component('DeleteModal', DeleteModal)
Vue.component('ErrorModal', ErrorModal)
Vue.component('ModalCompany', ModalCompany)
Vue.component('EditApplication', EditApplication)
Vue.component('AddResponsible', AddResponsible)
Vue.component('AddResponsibleForPdf', AddResponsibleForPdf)
// Components modals End

// Components tabs Start
Vue.component('tab', Tab)
Vue.component('TabResponsible', TabResponsible)
Vue.component('TabCalendar', TabCalendar)
// Components tabs End

// Components list Start
Vue.component('UserList', UserList)
Vue.component('ClientsList', ClientsList)
Vue.component('CompaniesList', CompaniesList)
// Components list End

// Components Start
Vue.component('search', Search)
Vue.component('SearchButton', SearchButton)
Vue.component('Select2', Select2)
Vue.component('draggable', draggable)
// Vue.component('NumberInputSpinner', NumberInputSpinner);
// Vue.component('Call', Call);
// Components End
